// extracted by mini-css-extract-plugin
export default {"p_tye":"f962e58d33","slcted":"_95543700ab","slc_color":"_14ae1809f9","item_p":"cb6cf16b36","r0":"b86e862311"};